import { Characteristic } from '../../types';

export const characteristicsTR: Characteristic[] = [
  // Varlik Kategorisi (Being)
  {
    id: 'ambition',
    name: 'Hirslilik',
    category: 'being',
    description: 'Hedef belirleme ve motivasyon seviyenizi yansitir',
  },
  {
    id: 'boldness',
    name: 'Cesaretlilik',
    category: 'being',
    description: 'Hesaplanmis risk alma konusundaki rahatliginizi olcer',
  },
  {
    id: 'integrity',
    name: 'Dogruluk',
    category: 'being',
    description: 'Ahlaki ilkelere bagliliginiZi degerlendirir',
  },
  {
    id: 'positiveOutlook',
    name: 'Olumlu Bakis Acisi',
    category: 'being',
    description: 'Yasama iyimser bakis acinizi degerlendirir',
  },
  // Eylem Kategorisi (Doing)
  {
    id: 'passion',
    name: 'Dinamik Enerji',
    category: 'doing',
    description: 'Duygusal motivasyonunuzu ve hevsinizi degerlendirir',
  },
  {
    id: 'sociability',
    name: 'Sosyallik',
    category: 'doing',
    description: 'Sosyal etkilesimlerdeki rahatliginizi olcer',
  },
  {
    id: 'communication',
    name: 'Iletisim',
    category: 'doing',
    description: 'Fikirleri net bir sekilde aktarma yeteneginizi degerlendirir',
  },
  {
    id: 'wisdom',
    name: 'Muhakeme',
    category: 'doing',
    description: 'Bilgiyi etkili bir sekilde uygulama yeteneginizi olcer',
  },
  // Sahip Olma Kategorisi (Having)
  {
    id: 'learning',
    name: 'Ogrenme',
    category: 'having',
    description: 'Surekli buyumeye olan bagliliginiZi degerlendirir',
  },
  {
    id: 'creativity',
    name: 'Yaraticilik',
    category: 'having',
    description: 'Yenilikci dusunme becerilerinizi degerlendirir',
  },
  {
    id: 'flexibility',
    name: 'Uyum Yetenegi',
    category: 'having',
    description: 'Degisime uyum saglamaniZi olcer',
  },
  {
    id: 'visionaryThinking',
    name: 'Vizyoner Dusunce',
    category: 'having',
    description: 'Gelecek olasiliklari gorme yeteneginizi degerlendirir',
  },
];
